import { flatten as _flatten, values as _values } from "lodash";

// Plz alphabetize
const mod = {
  namespaced: true,
  state: {
    addressStakeholders: [],
    campaignThankYouMessage: '',
    headerSettings: {},
    footerSettings: {},
    isMobile: false,
    loading: false,
    prefetchStakeholdersPayload: {},
    privacyPolicyDisclaimer: "",
    relationships: [],
    searchStakeholders: [],
    searchTerm: null,
    stakeholderError: false,
    stakeholderPrompts: {},
  },
  mutations: {
    addRelationship(state, id) {
      state.relationships.push(id);

      const addressStakeholder = _flatten(
        _values(state.addressStakeholders[0])
      ).find(stakeholder => stakeholder.stakeholderId === id);
      const searchStakeholder = state.searchStakeholders.find((stakeholder) => stakeholder.stakeholderId === id);

      if (!addressStakeholder && searchStakeholder) {
        // if level does not yet exist, add the level
        state.addressStakeholders[0][searchStakeholder.level] =
          state.addressStakeholders[0][searchStakeholder.level] || [];

        state.addressStakeholders[0][searchStakeholder.level].unshift(
          searchStakeholder
        );
      }
    },
    addressStakeholders(state, values) {
      state.addressStakeholders = values;
    },
    campaignThankYouMessage(state, values) {
      state.campaignThankYouMessage = values;
    },
    clearSearchStakeholders(state) {
      state.searchStakeholders = [];
    },
    headerSettings(state, headerData) {
      state.headerSettings = headerData;
    },
    footerSettings(state, footerData) {
      state.footerSettings = footerData;
    },
    isMobile(state, bool) {
      state.isMobile = bool;
    },
    loading(state, bool) {
      state.loading = bool;
    },
    prefetchStakeholdersPayload: (state, payload) => {
      state.prefetchStakeholdersPayload = payload;
    },
    privacyPolicyDisclaimer(state, value) {
      state.privacyPolicyDisclaimer = value;
    },
    searchStakeholders(state, values) {
      state.searchStakeholders = [
        ...state.searchStakeholders,
        ...values
      ];
    },
    searchTerm(state, term) {
      state.searchTerm = term;
    },
    stakeholderError(state, bool) {
      state.stakeholderError = bool;
    },
    stakeholderPrompts(state, prompts) {
      state.stakeholderPrompts = prompts;
    }
  },
  actions: {
    addressStakeholders({ commit }, values) {
      commit("addressStakeholders", values);
    },
    addRelationship({commit}, id) {
      commit("addRelationship", id);
    },
    clearSearchStakeholders({commit}) {
      commit("clearSearchStakeholders");
    },
    headerSettings({commit}, headerData) {
      commit("headerSettings", headerData)
    },
    footerSettings({commit}, footerData) {
      commit("footerSettings", footerData)
    },
    isMobile({commit}, bool) {
      commit("isMobile", bool)
    },
    loading({ commit }, bool) {
      commit("loading", bool);
    },
    prefetchStakeholdersPayload({ commit }, payload) {
      commit("prefetchStakeholdersPayload", payload);
    },
    privacyPolicyDisclaimer({ commit }, value) {
      commit("privacyPolicyDisclaimer", value);
    },
    stakeholderError({ commit }, bool) {
      commit("stakeholderError", bool)
    },
    stakeholderPrompts({ commit }, values) {
      commit("stakeholderPrompts", values)
    },
    searchStakeholders({ commit }, values) {
      commit("searchStakeholders", values);
    },
    searchTerm({ commit }, values) {
      commit("searchTerm", values);
    }
  },
  getters: {
    relationships(state) {
      return state.relationships;
    },
  }
};

export default mod;
